<template>
  <a
    class="widget-chat-message-attachment"
    :href="downloadUrl"
    target="_blank"
  >
    <slot />
  </a>
</template>

<script lang="ts" setup>
const { downloadUrl } = defineProps<{
  downloadUrl: string
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.widget-chat-message-attachment {
  display: block;

  &:hover {
    --widget-attachment-full-name-color: #{$blue};
  }
}
</style>
